import React, { useEffect, useState } from "react";
import {
	AntdTable,
	BodyContainer,
	Container,
	HeaderContainer,
	Section,
	StepContainer,
} from "./styles";
import { COLORS, SIZES, Typo } from "../../../../../../../layout/theme";
import { IoIosArrowRoundBack } from "react-icons/io";
import { Modal, Spin } from "antd";
import { BsDownload } from "react-icons/bs";
import CustomAntdTooltip from "../../../../../../../common/custom-antd-tooltip/CustomAntdTooltip";
import { download_crm_product_states_detail } from "../../../../../../../../api/endpoints/orders";
import moment from "moment";

const { confirm } = Modal;

export default function Step2StateDetail({
	stepData,
	handleBackStep,
	laboratoryId,
	selectedMonth,
	selectedYear,
	clientId,
}) {
	const [loading, setLoading] = useState(false);
	const [submitting, setSubmitting] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const columnCategories = [
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Producto
				</div>
			),
			dataIndex: "productTitle",
			render: (value, record) => (
				<Typo level={7} type="primary">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Ean
				</div>
			),
			width: 140,
			dataIndex: "productEan13",
			render: (value, record) => (
				<Typo level={7} type="muted">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Droguería
				</div>
			),
			dataIndex: "distributorName",
			render: (value, record) => (
				<Typo level={7} type="muted">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Unidades Totales
				</div>
			),
			dataIndex: "totalUnitsOrder",
			render: (value, record) => (
				<Typo level={7} type={"secondary"}>
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Facturados
				</div>
			),
			dataIndex: "totalUnitsBilled",
			render: (value, record) => (
				<Typo level={7} type={"secondary"}>
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Pendientes
				</div>
			),
			dataIndex: "totalUnitsPending",
			render: (value, record) => (
				<Typo level={7} type={"secondary"}>
					{value}
				</Typo>
			),
		},
	];

	const columnDistributors = [
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Producto
				</div>
			),
			dataIndex: "productTitle",
			render: (value, record) => (
				<Typo level={7} type="primary">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Ean
				</div>
			),
			width: 140,
			dataIndex: "productEan13",
			render: (value, record) => (
				<Typo level={7} type="muted">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Categoría
				</div>
			),
			dataIndex: "categoryName",
			render: (value, record) => (
				<Typo level={7} type="muted">
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Unidades Totales
				</div>
			),
			dataIndex: "totalUnitsOrder",
			render: (value, record) => (
				<Typo level={7} type={"secondary"}>
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Facturados
				</div>
			),
			dataIndex: "totalUnitsBilled",
			render: (value, record) => (
				<Typo level={7} type={"secondary"}>
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey, fontSize: SIZES.level7 }}>
					Pendientes
				</div>
			),
			dataIndex: "totalUnitsPending",
			render: (value, record) => (
				<Typo level={7} type={"secondary"}>
					{value}
				</Typo>
			),
		},
	];

	const handleDownloadFile = async () => {
		setLoading(true);
		try {
			const isCat = stepData?.step === 2;
			const res = await download_crm_product_states_detail({
				month: selectedMonth,
				year: selectedYear,
				clientId,
				categoryId: isCat ? stepData?.categoryId : null,
				distributorId: !isCat ? stepData?.distributorId : null,
			});

			const href = URL.createObjectURL(res);
			const link = document.createElement("a");
			link.href = href;
			const _fileName =
				"Ficha_Detalle_Productos_" + moment().format("DD-MM-YYYY") + ".xlsx";
			link.setAttribute("download", _fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (err) {
			console.log(err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<StepContainer>
			<HeaderContainer>
				<Section
					style={{ justifyContent: "start", gap: 90, padding: "0 10px" }}
				>
					<Container style={{ width: "100%", flex: "1 1 5%" }}>
						<Section
							onClick={() => handleBackStep(1)}
							style={{ cursor: "pointer", justifyContent: "start" }}
						>
							<IoIosArrowRoundBack size={19} color={COLORS.Secondary} />
							<Typo type="secondary" level={7}>
								Volver
							</Typo>
						</Section>
					</Container>
					<Container
						style={{
							width: "100%",
							flex: "1 1 90%",
							alignItems: "center",
						}}
					>
						<Section style={{ gap: 20 }}>
							<Typo type="grey" level={7}>
								{stepData?.step === 2 ? "Categoria" : "Drogueria"}
							</Typo>
							<Typo type="mediumGrey" level={7}>
								{stepData?.step === 2
									? stepData?.categoryName
									: stepData?.distributorName}
							</Typo>
						</Section>
					</Container>
					<Container style={{ width: "100%", flex: "1 1 5%" }}>
						<Section>
							{loading ? (
								<Spin size="small" />
							) : (
								<CustomAntdTooltip
									placement="left"
									width="105px"
									tooltipContent={[
										{
											body: "Exportar datos",
										},
									]}
								>
									<BsDownload
										size={18}
										color={COLORS.Secondary}
										style={{ cursor: "pointer" }}
										onClick={handleDownloadFile}
									/>
								</CustomAntdTooltip>
							)}
						</Section>
					</Container>
				</Section>
			</HeaderContainer>
			<BodyContainer>
				<AntdTable
					rowKey="productEan13"
					dataSource={stepData?.productList || []}
					loading={!stepData}
					columns={stepData?.step === 2 ? columnCategories : columnDistributors}
					pagination={false}
					scroll={{ y: "1020px" }}
				/>
			</BodyContainer>
		</StepContainer>
	);
}
